<template>
  <v-dialog width="452px" v-model="filter.flag">
    <v-card>
      <v-card-title class="title justify-space-between">
        <!-- <div v-if="parent_tab == 1" class="">Filter</div> -->
        <div v-if="parent_tab != 2" class="">Filter & Sort</div>
        <div v-else>Sort</div>
        <div>
          <v-btn icon @click="filter.flag = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="mt-3 pb-0">
        <div v-if="parent_tab == 2" class="exchanges mb-2">Filter</div>
        <div>
          <div v-if="parent_tab == 0" class="exchanges">Filter (Exchanges)</div>

          <div class="">
            <v-row v-if="parent_tab != 1" class="align-center">
              <v-col class="exchange" v-if="parent_tab == 2" cols="3" md="3"
                >Exchange</v-col
              >
              <v-col cols="6" :class="parent_tab == 0 ? 'pa-4 pl-2' : ''">
                <v-chip-group v-model="exchange" color="primary">
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="NSE"
                    label
                    outlined
                  >
                    NSE
                  </v-chip>
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="BSE"
                    label
                    outlined
                    >BSE
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <v-row v-if="parent_tab == 2" class="align-center">
              <v-col class="status" cols="3" md="3">Status</v-col>
              <v-col cols="6">
                <v-chip-group v-model="status" class="pb-0" color="primary">
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="Inactive"
                    label
                    outlined
                  >
                    Upcoming
                  </v-chip>
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="Active"
                    label
                    outlined
                    >Live
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <v-row v-if="parent_tab == 2" class="align-center">
              <v-col class="duration pt-0" cols="3" md="3">Duration</v-col>
              <v-col cols="9" md="9" class="pl-0 pt-0">
                <v-chip-group v-model="duration" class="pb-0" color="primary">
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="1"
                    label
                    outlined
                  >
                    Intraday
                  </v-chip>
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="3"
                    label
                    outlined
                    >Swing
                  </v-chip>
                  <v-chip
                    :small="$vuetify.breakpoint.xsOnly"
                    value="4"
                    label
                    outlined
                    >Long Term
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </div>
          <v-divider v-if="parent_tab != 1"> </v-divider>

          <div class="exchanges">Sort</div>
          <!-- for security and traders -->
          <!-- Alphabatically -->
          <div
            v-if="parent_tab != 1"
            class="d-flex sort-method justify-space-between"
          >
            <div class="sort-symbol">
              A-Z <span class="sort-text">Alphabetically</span>
            </div>
            <div>
              <v-icon
                v-if="!alpha"
                @click="sortAlphabetically(null)"
                color="grey"
                >mdi-sort-alphabetical-ascending
              </v-icon>
              <v-icon
                v-if="alpha == 1"
                @click="sortAlphabetically(1)"
                color="primary"
                >mdi-sort-alphabetical-ascending
              </v-icon>
              <v-icon
                v-if="alpha == 2"
                @click="sortAlphabetically(2)"
                color="primary"
                >mdi-sort-alphabetical-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab != 1"> </v-divider>

          <!-- P&L -->
          <div
            v-if="parent_tab == 2"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for traders-->
            <div class="sort-symbol">
              P&L <span class="sort-text">Profit & Loss</span>
            </div>
            <div>
              <v-icon
                v-if="!profit_loss"
                @click="sortProfitLoss(null)"
                color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="profit_loss == 1"
                @click="sortProfitLoss(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="profit_loss == 2"
                @click="sortProfitLoss(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 2"> </v-divider>

          <!-- Chnange -->
          <div
            v-if="parent_tab != 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              % <span class="sort-text">Change</span>
            </div>
            <div>
              <v-icon v-if="!change" @click="sortChange(null)" color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon v-if="change == 1" @click="sortChange(1)" color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon v-if="change == 2" @click="sortChange(2)" color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab != 1"> </v-divider>

          <!-- LTP -->
          <div
            v-if="parent_tab != 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              LTP <span class="sort-text">Last Traded Price</span>
            </div>
            <div>
              <v-icon
                v-if="!last_trade"
                @click="sortLastTradePrice(null)"
                color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="last_trade == 1"
                @click="sortLastTradePrice(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="last_trade == 2"
                @click="sortLastTradePrice(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab != 1"> </v-divider>

          <!-- for trade only -->
          <div
            v-if="parent_tab == 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              # <span class="sort-text">Closed Trades</span>
            </div>
            <div>
              <v-icon
                v-if="!closed"
                @click="sortClosedTrades(null)"
                color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="closed == 1"
                @click="sortClosedTrades(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="closed == 2"
                @click="sortClosedTrades(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 1"> </v-divider>

          <div
            v-if="parent_tab == 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              % <span class="sort-text">Accuracy</span>
            </div>
            <div>
              <v-icon v-if="!accuracy" @click="sortAccuracy(null)" color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="accuracy == 1"
                @click="sortAccuracy(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="accuracy == 2"
                @click="sortAccuracy(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 1"> </v-divider>

          <div
            v-if="parent_tab == 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              Days <span class="sort-text">Holding Period</span>
            </div>
            <div>
              <v-icon
                v-if="!holding_period"
                @click="sortHoldingPeriod(null)"
                color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="holding_period == 1"
                @click="sortHoldingPeriod(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="holding_period == 2"
                @click="sortHoldingPeriod(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 1"> </v-divider>

          <div
            v-if="parent_tab == 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              Ratio <span class="sort-text">Risk Reward</span>
            </div>
            <div>
              <v-icon
                v-if="!risk_reward"
                @click="sortRiskReward(null)"
                color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="risk_reward == 1"
                @click="sortRiskReward(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="risk_reward == 2"
                @click="sortRiskReward(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 1"> </v-divider>

          <div
            v-if="parent_tab == 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">
              % <span class="sort-text">Average Trade Return</span>
            </div>
            <div>
              <v-icon
                v-if="!avg_trade"
                @click="sortAverageTrade(null)"
                color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="avg_trade == 1"
                @click="sortAverageTrade(1)"
                color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon
                v-if="avg_trade == 2"
                @click="sortAverageTrade(2)"
                color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 1"> </v-divider>

          <div
            v-if="parent_tab == 1"
            class="d-flex sort-method justify-space-between"
          >
            <!-- for security and traders -->
            <div class="sort-symbol">% <span class="sort-text">ROI </span></div>
            <div>
              <v-icon v-if="!roi" @click="sortROI(null)" color="grey"
                >mdi-sort-ascending
              </v-icon>
              <v-icon v-if="roi == 1" @click="sortROI(1)" color="primary"
                >mdi-sort-ascending
              </v-icon>
              <v-icon v-if="roi == 2" @click="sortROI(2)" color="primary"
                >mdi-sort-descending
              </v-icon>
            </div>
          </div>
          <v-divider v-if="parent_tab == 1"> </v-divider>
        </div>
      </v-card-text>
      <v-card-actions class="pt-0 pb-3 justify-space-between">
        <v-btn
          @click="clear"
          class="text-capitalize"
          outlined
          color="primary"
          width="50%"
          >Clear</v-btn
        >

        <v-btn
          @click="submit()"
          class="text-capitalize"
          color="primary"
          width="50%"
          >Apply</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "filterModal",
  // props: ["filter"],
  props: {
    filter: Object,
    parent_tab: Number,
  },
  data() {
    return {
      alpha: null,
      profit_loss: null,
      change: null,
      last_trade: null,
      closed: null,
      accuracy: null,
      holding_period: null,
      risk_reward: null,
      avg_trade: null,
      roi: null,
      exchange: null,
      status: null,
      duration: null,
    };
  },
  methods: {
    submit() {
      this.eventBus.$emit("filter-and-sort", {
        exchange: this.exchange,
        status: this.status,
        duration: this.duration,
        alpha: this.alpha,
        percentChange: this.change,
        ltp: this.last_trade,
        profit_loss: this.profit_loss,
        closed: this.closed,
        accuracy: this.accuracy,
        holding_period: this.holding_period,
        risk_reward: this.risk_reward,
        avg_trade: this.avg_trade,
        roi: this.roi,
      });
      this.filter.flag = false;
    },

    clear() {
      this.eventBus.$emit("filter-and-sort", {
        exchange: null,
        status: null,
        duration: null,
        alpha: null,
        percentChange: null,
        ltp: null,
        profit_loss: null,
        closed: null,
        accuracy: null,
        holding_period: null,
        risk_reward: null,
        avg_trade: null,
        roi: null,
      });

      this.alpha = null;
      this.change = null;
      this.last_trade = null;
      this.exchange = null;
      this.status = null;
      this.duration = null;
      this.profit_loss = null;
      this.closed = null;
      this.accuracy = null;
      this.holding_period = null;
      this.risk_reward = null;
      this.avg_trade = null;
      this.roi = null;
    },
    sortAlphabetically(value) {
      switch (value) {
        case null:
          this.alpha = 1;
          break;
        case 1:
          this.alpha = 2;
          break;
        default:
          this.alpha = null;
      }
    },
    sortProfitLoss(value) {
      switch (value) {
        case null:
          this.profit_loss = 1;
          break;
        case 1:
          this.profit_loss = 2;
          break;
        default:
          this.profit_loss = null;
      }
    },
    sortChange(value) {
      switch (value) {
        case null:
          this.change = 1;
          break;
        case 1:
          this.change = 2;
          break;
        default:
          this.change = null;
      }
    },
    sortLastTradePrice(value) {
      switch (value) {
        case null:
          this.last_trade = 1;
          break;
        case 1:
          this.last_trade = 2;
          break;
        default:
          this.last_trade = null;
      }
    },
    sortClosedTrades(value) {
      switch (value) {
        case null:
          this.closed = 1;
          break;
        case 1:
          this.closed = 2;
          break;
        default:
          this.closed = null;
      }
    },
    sortAccuracy(value) {
      switch (value) {
        case null:
          this.accuracy = 1;
          break;
        case 1:
          this.accuracy = 2;
          break;
        default:
          this.accuracy = null;
      }
    },
    sortHoldingPeriod(value) {
      switch (value) {
        case null:
          this.holding_period = 1;
          break;
        case 1:
          this.holding_period = 2;
          break;
        default:
          this.holding_period = null;
      }
    },
    sortRiskReward(value) {
      switch (value) {
        case null:
          this.risk_reward = 1;
          break;
        case 1:
          this.risk_reward = 2;
          break;
        default:
          this.risk_reward = null;
      }
    },
    sortAverageTrade(value) {
      switch (value) {
        case null:
          this.avg_trade = 1;
          break;
        case 1:
          this.avg_trade = 2;
          break;
        default:
          this.avg_trade = null;
      }
    },
    sortROI(value) {
      switch (value) {
        case null:
          this.roi = 1;
          break;
        case 1:
          this.roi = 2;
          break;
        default:
          this.roi = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-chip.v-chip--outlined.v-chip.v-chip {
  border: 1px solid #4f4f4f;
}
.exchange,
.status,
.duration {
  color: rgba(51, 51, 51, 0.8);
  font-family: Avenir;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
@media only screen and (max-width: 768px) {
  .exchange,
  .status,
  .duration {
    color: rgba(51, 51, 51, 0.8);
    font-family: Avenir;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    // padding: initial;
  }
}
.title {
  color: #fff;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.625rem; /* 130% */
  background: var(--Primary-Blue, #2d8cff);
}
.exchanges {
  color: rgba(51, 51, 51, 0.9);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.sort-symbol {
  color: rgba(51, 51, 51, 0.9);
  text-align: right;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.sort-text {
  color: rgba(51, 51, 51, 0.8);
  font-family: Avenir;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.sort-method {
  margin: 12px 0;
}
</style>
